import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';

const FloatingCart = () => {
  const { setIsCartOpen, itemCount, isCartOpen } = useCart();

  // Sakrij ako je korpa prazna ILI ako je cart drawer otvoren
  if (itemCount === 0 || isCartOpen) return null;

  const buttonStyle = {
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    left: 'auto',
    background: '#d4a853',
    color: '#0a0a0a',
    border: 'none',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
    zIndex: 9998,
    boxShadow: '0 4px 20px rgba(212, 168, 83, 0.4)',
    borderRadius: '50px',
    fontFamily: 'Inter, sans-serif'
  };

  const countStyle = {
    background: '#0a0a0a',
    color: '#d4a853',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    fontWeight: '700'
  };

  const textStyle = {
    fontWeight: '600',
    fontSize: '14px',
    letterSpacing: '1px'
  };

  return (
    <button 
      style={buttonStyle}
      onClick={() => setIsCartOpen(true)}
      aria-label="Otvori korpu"
    >
      <ShoppingBag size={24} />
      <span style={countStyle}>{itemCount}</span>
      <span style={textStyle}>Korpa</span>
    </button>
  );
};

export default FloatingCart;
